import { createContext, useContext } from "react";
import type {
  HqImpersonation,
  SchoolMemberRole,
} from "@kindtutor/api-contract";

export type CurrentSchool = {
  schoolId: string;
  schoolName: string;
  role: SchoolMemberRole;
  impersonation: HqImpersonation | null;
};

export const CurrentSchoolContext = createContext<CurrentSchool | null>(null);

export function useCurrentSchool() {
  const school = useContext(CurrentSchoolContext);
  if (!school) throw new Error("Current school context is missing");
  return school;
}
